import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import classnames from 'classnames';

import {CueCard} from 'shells/cue-card/cue-card';

import {analyticsClient} from '../../../analytics-client';
import {appHistory} from '../../../history';
import type {NutshellState} from '../../../store';

import {openIntercomArticle} from '../../intercom';
import {openableModalActions, OpenableModals} from '../../openable-modals';

import type {CueCard as CueCardType} from '../consts/cue-card-collection';
import {getGlossaryKey} from '../redux/glossary-selectors';

import styles from './cue-card-stack.module.css';

type Props = {
    cards: CueCardType[];
    afterOnClickCta?: () => any;
    onMinimize?: (settingsKey: string) => any;
    withBottomMargin?: boolean;
    noBookmark?: boolean;
};

export function CueCardStack(props: Props) {
    const isGlossary = useSelector((state: NutshellState) => getGlossaryKey(state));
    const dispatch = useDispatch();

    return (
        <div
            className={classnames(props.withBottomMargin ? 'mb-16' : '', styles['cue-card-stack'])}
        >
            {props.cards.map((card, index) => {
                let cta;
                if (card.cta) {
                    const {openableModalId, intercomArticleId, youTubeVideoId, ...cardCta} =
                        card.cta;
                    cta = {
                        ...cardCta,
                        onClick: () => {
                            if (openableModalId) {
                                dispatch(openableModalActions.openModal(openableModalId));
                            } else if (intercomArticleId) {
                                openIntercomArticle(intercomArticleId);
                            } else if (youTubeVideoId) {
                                dispatch(
                                    openableModalActions.openModal(OpenableModals.YOUTUBE_MODAL, {
                                        videoId: youTubeVideoId,
                                    })
                                );
                            }

                            analyticsClient.track('cue_clicked', {
                                settingsKey: card.settingsKey,
                                openedFrom: isGlossary ? 'glossary' : card.location,
                            });

                            if (props.afterOnClickCta) {
                                props.afterOnClickCta();
                            }
                        },
                    };
                }

                return (
                    <CueCard
                        key={card.settingsKey}
                        title={card.title}
                        description={card.description}
                        thumbnailIllustration={card.thumbnailPath}
                        thumbnailPosition={card.thumbnailPosition}
                        thumbnailBackgroundColor={card.backgroundColor}
                        cta={cta}
                        onMinimize={
                            props.onMinimize && card.isDismissable !== false
                                ? () => {
                                      // @ts-expect-error
                                      props.onMinimize(card.settingsKey);
                                  }
                                : undefined
                        }
                        withBookmarkIcon={!props.noBookmark && index === 0}
                        history={appHistory}
                    />
                );
            })}
        </div>
    );
}
